import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from 'components/Box'
import Text from 'components/Text'

import { LeadProcessChangedData, Notification } from 'types/global'

import NotificationHeader from './NotificationHeader'
import NotificationFooter from './NotificationFooter'

type Props = Notification & {
  data: LeadProcessChangedData
}

const LeadProcessStageUpdate: React.FC<Props> = ({ data: { affectedLeadsCount, leadProcessName }, ...props }) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" paddingLeft="10px" width="100%" flexDirection="column">
      <NotificationHeader {...props} title="notification_pipeline_update_title_lbl" />
      <Box display="flex" paddingTop="4px">
        <Text lineHeight="22px">
          {t('notification_pipeline_change_body', {
            affectedLeadsCount,
            leadProcessName,
          })}
        </Text>
      </Box>
      <NotificationFooter {...props} />
    </Box>
  )
}

export default LeadProcessStageUpdate
